export default function flattenObject(obj) {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (value === null || Array.isArray(value)) acc[key] = value;
    else if (typeof value === 'object') {
      Object.entries(value).forEach(([subKey, subValue]) => {
        acc[`${key}.${subKey}`] = subValue;
      });
    } else acc[key] = value;

    return acc;
  }, {})
}
